import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0df83005&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/components/wechat/css/wechat.less?vue&type=style&index=0&id=0df83005&lang=less&scoped=true&"
import style1 from "@/components/wechat/css/wechat.scss?vue&type=style&index=1&id=0df83005&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df83005",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0df83005')) {
      api.createRecord('0df83005', component.options)
    } else {
      api.reload('0df83005', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0df83005&scoped=true&", function () {
      api.rerender('0df83005', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mp/wxmenu/index.vue"
export default component.exports